import React from "react";

interface Props {
  fill?: string;
  stroke?: string;
  className?: string;
}

export const dashboard: React.FC<Props> = ({
  className = "w-[12px] h-[12px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666992 8.33301H4.66699C4.84942 8.33319 5 8.48453 5 8.66699V11.333C5 11.5155 4.84942 11.6668 4.66699 11.667H0.666992C0.48442 11.667 0.333008 11.5156 0.333008 11.333V8.66699C0.333008 8.48442 0.48442 8.33301 0.666992 8.33301ZM7.33301 5.66699H11.333C11.5156 5.66699 11.667 5.81743 11.667 6V11.333C11.667 11.5156 11.5156 11.667 11.333 11.667H7.33301C7.15058 11.6668 7 11.5155 7 11.333V6C7 5.81754 7.15058 5.66717 7.33301 5.66699ZM0.666992 0.333008H4.66699C4.84942 0.333187 5 0.484529 5 0.666992V6C5 6.18246 4.84942 6.33283 4.66699 6.33301H0.666992C0.48442 6.33301 0.333008 6.18257 0.333008 6V0.666992C0.333008 0.48442 0.48442 0.333008 0.666992 0.333008ZM7.33301 0.333008H11.333C11.5156 0.333008 11.667 0.48442 11.667 0.666992V3.33301C11.667 3.51558 11.5156 3.66699 11.333 3.66699H7.33301C7.15058 3.66681 7 3.51547 7 3.33301V0.666992C7 0.484529 7.15058 0.333187 7.33301 0.333008Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const contact: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33362 9C6.06866 9.00006 7.19336 9.18651 8.12561 9.55957C8.59143 9.74599 8.98823 9.97095 9.26331 10.2246C9.53613 10.4762 9.66663 10.7342 9.66663 11V12C9.66645 12.1823 9.51594 12.3328 9.33362 12.333H1.33362C1.15115 12.333 0.999813 12.1824 0.999634 12V11C0.999634 10.7342 1.1302 10.4762 1.40295 10.2246C1.67806 9.9709 2.0757 9.74602 2.54163 9.55957C3.47393 9.18657 4.59869 9 5.33362 9ZM10.8619 9.00586C11.5912 9.03495 12.6055 9.21819 13.4586 9.55957C13.9244 9.74596 14.3212 9.97099 14.5963 10.2246C14.8691 10.4762 14.9996 10.7342 14.9996 11V12C14.9995 12.1824 14.8491 12.333 14.6666 12.333H11.6383C11.6551 12.2248 11.6666 12.1136 11.6666 12V11C11.6666 10.19 11.3469 9.53279 10.8619 9.00586ZM5.33362 3.66602C6.25459 3.66619 6.99377 4.40909 6.99377 5.33301C6.99377 6.25692 6.25459 6.99983 5.33362 7C4.41105 7 3.66663 6.25558 3.66663 5.33301C3.66663 4.41044 4.41105 3.66602 5.33362 3.66602ZM10.6666 3.66602C11.5877 3.66602 12.3268 4.40898 12.3268 5.33301C12.3268 6.25703 11.5877 7 10.6666 7C9.74405 7 8.99963 6.25558 8.99963 5.33301C8.99963 4.41044 9.74405 3.66602 10.6666 3.66602Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const chat: React.FC<Props> = ({
  className = "w-[14px] h-[14px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66638 0.666016H12.3334C12.8825 0.666016 13.3332 1.11692 13.3334 1.66602V9.66602C13.3334 10.2153 12.8826 10.666 12.3334 10.666H2.86169L0.666382 12.8613V1.66602C0.66656 1.11703 1.1174 0.666194 1.66638 0.666016Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const agenda: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.333 1.66602C11.5156 1.66602 11.667 1.81743 11.667 2V3H12.667C13.2161 3.00018 13.667 3.45087 13.667 4V13.333C13.667 13.8821 13.2161 14.3328 12.667 14.333H3.33301C2.77834 14.3328 2.33301 13.8832 2.33301 13.333L2.33984 4L2.34473 3.89746C2.39511 3.3931 2.81502 3.00016 3.33301 3H4.33301V2C4.33301 1.81743 4.48442 1.66602 4.66699 1.66602C4.84942 1.66619 5 1.81754 5 2V3H11V2C11 1.81754 11.1506 1.66619 11.333 1.66602ZM3 13.666H13V6.33301H3V13.666ZM5.33301 11C5.51558 11 5.66699 11.1504 5.66699 11.333C5.66699 11.5156 5.51558 11.666 5.33301 11.666C5.15058 11.6658 5 11.5155 5 11.333C5 11.1505 5.15058 11.0002 5.33301 11ZM8 11C8.18257 11 8.33301 11.1504 8.33301 11.333C8.33301 11.5156 8.18257 11.666 8 11.666C7.81743 11.666 7.66699 11.5156 7.66699 11.333C7.66699 11.1504 7.81743 11 8 11ZM10.667 11C10.8494 11.0002 11 11.1505 11 11.333C11 11.5155 10.8494 11.6658 10.667 11.666C10.4844 11.666 10.333 11.5156 10.333 11.333C10.333 11.1504 10.4844 11 10.667 11ZM5.33301 8.33301C5.51547 8.33301 5.66681 8.48359 5.66699 8.66602C5.66699 8.84859 5.51558 9 5.33301 9C5.15058 8.99982 5 8.84848 5 8.66602C5.00018 8.4837 5.15069 8.33319 5.33301 8.33301ZM8 8.33301C8.18246 8.33301 8.33283 8.48359 8.33301 8.66602C8.33301 8.84859 8.18257 9 8 9C7.81743 9 7.66699 8.84859 7.66699 8.66602C7.66717 8.48359 7.81754 8.33301 8 8.33301ZM10.667 8.33301C10.8493 8.33319 10.9998 8.4837 11 8.66602C11 8.84848 10.8494 8.99982 10.667 9C10.4844 9 10.333 8.84859 10.333 8.66602C10.3332 8.48359 10.4845 8.33301 10.667 8.33301Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const assistance: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33301 1.47266H12.667C13.216 1.47283 13.6668 1.92367 13.667 2.47266V11.8066C13.6668 12.3556 13.216 12.8065 12.667 12.8066H9.8623L9.76465 12.9033L8.23145 14.4297V14.4307C8.11791 14.5442 7.94318 14.5587 7.81445 14.4736L7.7627 14.4307L6.23535 12.9043L6.1377 12.8066H3.33301C2.78403 12.8065 2.33319 12.3556 2.33301 11.8066V2.47266C2.33319 1.92367 2.78403 1.47283 3.33301 1.47266ZM7.69629 3.00098L6.49414 5.63379L3.86133 6.83594L3.19727 7.13965L3.86133 7.44336L6.49414 8.64453L7.69629 11.2783L8 11.9424L8.30371 11.2783L9.50488 8.64453L12.1387 7.44336L12.8027 7.13965L12.1387 6.83594L9.50488 5.63379L8.30371 3.00098L8 2.33691L7.69629 3.00098Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const compains: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3441 11.3906C11.4447 11.2686 11.6072 11.2357 11.7377 11.2969L11.7933 11.3301L12.8656 12.1357L12.8705 12.1396C13.0107 12.2416 13.0434 12.4427 12.933 12.5898L12.8998 12.6328C12.8072 12.734 12.6583 12.7657 12.5306 12.7051L12.473 12.6699L11.391 11.8613L11.389 11.8604L11.3422 11.8184C11.2429 11.7105 11.2305 11.5453 11.3265 11.417L11.3256 11.416C11.33 11.4103 11.3363 11.4047 11.3412 11.3975C11.3423 11.3958 11.3426 11.393 11.3441 11.3906ZM8.33337 11.4141L5.50525 9.71777L5.42615 9.66992H4.33337V12.0029C4.33337 12.1854 4.18279 12.3367 4.00037 12.3369C3.81779 12.3369 3.66638 12.1855 3.66638 12.0029V9.66992H2.66638C2.11729 9.66974 1.66638 9.21905 1.66638 8.66992V7.33691C1.66638 6.78778 2.11729 6.33709 2.66638 6.33691H5.42615L5.50525 6.28906L8.33337 4.5918V11.4141ZM9.66638 6.71777C9.87737 7.09918 10.0003 7.53684 10.0004 8.00293C10.0004 8.46913 9.87693 8.90652 9.66638 9.28613V6.71777ZM12.6664 7.66992H14.0004C14.1827 7.6701 14.3332 7.82063 14.3334 8.00293C14.3334 8.18539 14.1828 8.33674 14.0004 8.33691H12.6664C12.484 8.33673 12.3334 8.18539 12.3334 8.00293C12.3336 7.82063 12.4841 7.6701 12.6664 7.66992ZM12.4828 3.32812C12.6129 3.22825 12.8044 3.2469 12.9183 3.37988L12.9369 3.40625C13.035 3.54118 13.0198 3.71443 12.9261 3.82129L12.8812 3.8623L12.8793 3.86426L11.8021 4.6748L11.8002 4.67676C11.6641 4.77881 11.4819 4.7591 11.3685 4.63379L11.3383 4.59375C11.2438 4.47063 11.2518 4.30033 11.3519 4.1875L11.3998 4.14355L11.4037 4.14062L12.4808 3.3291L12.4828 3.32812ZM11.3158 4.57031C11.3179 4.57247 11.3213 4.57627 11.3256 4.58105C11.3284 4.58425 11.3307 4.58921 11.3344 4.59375C11.3316 4.59043 11.3298 4.58656 11.3275 4.58398C11.323 4.57892 11.3193 4.57485 11.3168 4.57227C11.3155 4.57094 11.3145 4.56905 11.3138 4.56836L11.3158 4.57031Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const settings: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75989 1.6665H9.24622C9.39028 1.6665 9.51944 1.76432 9.56262 1.8999L9.57532 1.95947L9.57629 1.96143L9.76868 3.50146L9.79211 3.68506L9.96008 3.76221C10.2135 3.87963 10.4564 4.02287 10.6886 4.18604L10.84 4.29248L11.0099 4.22021L12.4435 3.61377L12.4464 3.61279C12.5772 3.55598 12.7297 3.59284 12.8214 3.70068L12.8566 3.75146L12.8585 3.75342L14.1046 5.90674C14.1789 6.03951 14.156 6.19849 14.0636 6.30029L14.0197 6.34033L14.0187 6.34131L12.7784 7.28076L12.632 7.39209L12.6476 7.57568C12.6601 7.71988 12.6661 7.85725 12.6661 8.00049C12.6661 8.14374 12.6603 8.27554 12.6427 8.41064L12.6173 8.60205L12.7716 8.71924L14.0089 9.65576V9.65674C14.1439 9.76134 14.181 9.94446 14.0978 10.0933L12.8517 12.2466L12.8497 12.2485C12.7771 12.3764 12.6318 12.4374 12.4962 12.4067L12.4396 12.3882L12.4366 12.3862L11.0031 11.7798L10.8331 11.7075L10.6818 11.814C10.4496 11.9771 10.2066 12.1204 9.95325 12.2378L9.78528 12.3149L9.76282 12.4985L9.56946 14.0386L9.56848 14.0405C9.54854 14.2062 9.40467 14.3333 9.24036 14.3335H6.75305C6.60931 14.3334 6.48101 14.2362 6.43762 14.1011L6.42395 14.0405V14.0386L6.23059 12.4985L6.20715 12.3149L6.04016 12.2378L5.85168 12.145C5.66565 12.0476 5.48576 11.9363 5.31165 11.814L5.16028 11.7075L4.99036 11.7798L3.55676 12.3862L3.55383 12.3882C3.42298 12.4451 3.27053 12.4072 3.17883 12.2993L3.1427 12.2485L3.14172 12.2466L1.89563 10.0952H1.89661C1.82118 9.96235 1.84329 9.80298 1.93567 9.70068L1.97961 9.66064L1.98157 9.65869L3.22083 8.71924L3.36829 8.60791L3.35168 8.42432C3.33917 8.28035 3.33314 8.1435 3.33313 8.00049C3.33313 7.85704 3.33928 7.71995 3.35168 7.5835L3.36829 7.3999L3.22083 7.2876L1.9845 6.3501C1.84945 6.24544 1.81225 6.06242 1.89563 5.91357L3.14172 3.75342L3.1427 3.75146C3.21524 3.6238 3.3608 3.56384 3.49622 3.59424L3.55383 3.61279L3.55676 3.61377L4.99036 4.22021L5.16028 4.29248L5.31165 4.18604C5.54383 4.02289 5.7868 3.87962 6.04016 3.76221L6.20715 3.68506L6.23059 3.50146L6.42395 1.96143V1.95947C6.44378 1.79585 6.58673 1.66651 6.75989 1.6665ZM8.02649 5.3335C6.55576 5.33354 5.3595 6.52975 5.3595 8.00049C5.35967 9.47108 6.55587 10.6665 8.02649 10.6665C9.49714 10.6665 10.6933 9.4711 10.6935 8.00049C10.6935 6.52973 9.49725 5.3335 8.02649 5.3335Z"
      fill="#FAFAFA"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const logout: React.FC<Props> = ({
  className = "w-[12px] h-[12px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33301 0.333008H5.66699V1H1V11H5.66699V11.667H1.33301C0.784025 11.6668 0.333186 11.216 0.333008 10.667V1.33301C0.333186 0.784025 0.784025 0.333186 1.33301 0.333008ZM11.5283 6L9.33398 8.19336L8.86328 7.7207L9.68262 6.90234L10.251 6.33301H4.33301V5.66699H10.248L9.68359 5.09863L8.86328 4.27344L9.33301 3.80469L11.5283 6Z"
      fill="black"
      stroke="#FAFAFA"
      strokeWidth="0.666667"
    />
  </svg>
);

export const unfold: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9404 5.4126L13.5283 8.00049L10.9395 10.5825L10.4707 10.1138L12.3486 8.23584L12.585 8.00049L12.3486 7.76416L10.4697 5.88623L10.9404 5.4126ZM5.05957 5.41846L5.52832 5.88721L3.41504 8.00049L3.65137 8.23584L5.5293 10.1147L5.05859 10.5884L2.4707 8.00049L5.05957 5.41846Z"
      fill="black"
      stroke="#E4E4E7"
      strokeWidth="0.666667"
    />
  </svg>
);

export const search: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.91382 2.65576L7.15698 2.67822C8.76918 2.87399 10.1267 4.08856 10.5281 5.64697L10.5955 5.96338C10.8047 7.21398 10.4233 8.38828 9.68433 9.25049L9.48511 9.48193L9.25366 9.68115C8.39132 10.4203 7.21639 10.8018 5.96558 10.5923H5.96655C4.36514 10.3215 3.06273 9.04828 2.73413 7.47314L2.6814 7.15381C2.3712 4.63045 4.41754 2.49568 6.91382 2.65576ZM6.65112 3.31396C4.80703 3.31396 3.31714 4.80385 3.31714 6.64795C3.31726 8.49194 4.80711 9.98096 6.65112 9.98096C8.49503 9.98083 9.984 8.49186 9.98413 6.64795C9.98413 4.80393 8.49511 3.31409 6.65112 3.31396ZM9.98413 9.98682L9.89038 9.89014L9.81909 9.81592L9.89331 9.88721L9.98999 9.98096H10.5125L13.241 12.7231H13.2419C13.3851 12.8663 13.3851 13.1024 13.2419 13.2456C13.0988 13.3887 12.8626 13.3887 12.7195 13.2456L9.98413 10.5093V9.98682Z"
      fill="#71717A"
      stroke="#71717A"
      strokeWidth="0.666667"
    />
  </svg>
);

export const filter: React.FC<Props> = ({
  className = "w-[16px] h-[16px]",
  fill = "fill-[#71717A]",
  stroke = "stroke-[#71717A]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 8.55249L6.92969 8.46167L6.92871 8.45972C6.92761 8.4583 6.92504 8.45667 6.92285 8.45386C6.9185 8.44826 6.91278 8.43937 6.9043 8.42847L6.54883 7.97144C6.31028 7.66476 5.97528 7.23557 5.59277 6.7439L3.09668 3.53491C2.94898 3.34225 3.04957 3.07759 3.2627 3.0144L3.36035 2.99976H12.6338C12.885 2.99997 13.0313 3.24418 12.9512 3.45093L12.9033 3.53491C12.13 4.52829 11.1722 5.76056 10.4072 6.7439C10.0249 7.2354 9.69068 7.66479 9.45215 7.97144L9.09668 8.42847C9.08812 8.43948 9.08152 8.44823 9.07715 8.45386C9.07512 8.45646 9.07336 8.45831 9.07227 8.45972L9.07031 8.46167L9 8.55249V11.9998C9 12.549 8.54924 12.9998 8 12.9998C7.45082 12.9997 7 12.549 7 11.9998V8.55249Z"
      fill={fill}
      className={stroke}
      strokeWidth="0.666667"
    />
  </svg>
);

export const edit: React.FC<Props> = ({
  className = "w-[18px] h-[18px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.24902 13.0959V15.3759C2.24902 15.5859 2.41402 15.7509 2.62402 15.7509H4.90402C5.00152 15.7509 5.09902 15.7134 5.16652 15.6384L13.3565 7.4559L10.544 4.6434L2.36152 12.8259C2.28652 12.9009 2.24902 12.9909 2.24902 13.0959ZM15.5315 5.2809C15.824 4.9884 15.824 4.5159 15.5315 4.2234L13.7765 2.4684C13.484 2.1759 13.0115 2.1759 12.719 2.4684L11.3465 3.8409L14.159 6.6534L15.5315 5.2809Z"
      fill="#FAFAFA"
    />
  </svg>
);

export const delte: React.FC<Props> = ({
  className = "w-[18px] h-[18px]",
}: Props) => (
  <svg
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 14.25C4.5 15.075 5.175 15.75 6 15.75H12C12.825 15.75 13.5 15.075 13.5 14.25V6.75C13.5 5.925 12.825 5.25 12 5.25H6C5.175 5.25 4.5 5.925 4.5 6.75V14.25ZM13.5 3H11.625L11.0925 2.4675C10.9575 2.3325 10.7625 2.25 10.5675 2.25H7.4325C7.2375 2.25 7.0425 2.3325 6.9075 2.4675L6.375 3H4.5C4.0875 3 3.75 3.3375 3.75 3.75C3.75 4.1625 4.0875 4.5 4.5 4.5H13.5C13.9125 4.5 14.25 4.1625 14.25 3.75C14.25 3.3375 13.9125 3 13.5 3Z"
      fill="#FAFAFA"
    />
  </svg>
);
